import icons from './data';

import SystemIcon from './icon.vue';

export { icons };

export default SystemIcon;
